import request from '@/utils/request'

let RegionagentApi = {

    /*代理列表*/
    getList(data) {
        return request._post('/shop/plus.datashare.shop/index', data);
    },

    /*获取设置*/
    getSetting(data) {
        return request._get('/shop/plus.datashare.shop/setting', data);
    },
    /*保存设置*/
    saveSetting(data) {
        return request._post('/shop/plus.datashare.shop/setting', data);
    },
    /*复制*/
    copy(data) {
        return request._post('/shop/plus.datashare.shop/copy', data);
    },


}

export default RegionagentApi;



// WEBPACK FOOTER //
// ./src/api/datashare.js